import { DateTimeFormatter } from '../../../formatters';
import { FlightParkedTooltipData } from '../../../services/map-interaction-service';

export function FlightParkedTooltip(props: { info: FlightParkedTooltipData }) {
    const context = props.info;
    return (
        <div style={{ width: 200, fontSize: 12 }}>
            <div className="text-center bg-color p-1" style={{ fontSize: '1.15em' }}>
                Parked ({context.flights.length})
            </div>
            <div style={{ fontSize: '1em' }}>
                <div className={'px-2'} style={{ padding: '0.25em 0', display: 'grid', gridTemplateColumns: '1.1fr 1.3fr 0.8fr' }}>
                    {context.flights.map((x) => (
                        <>
                            <div>{x.acid} </div>
                            <div>{DateTimeFormatter.formatTime(x.time, 'hm')}</div>
                            <div>{x.aircraftType}</div>
                        </>
                    ))}
                </div>
            </div>
        </div>
    );
}
